import api from 'api';

const loginUrl = 'api/auth/login';
const profileUrl = 'api/user';

export default {
    login: (email, password) => api.post({path: loginUrl, params:{email, password}}),
    profile: () => api.get({path: profileUrl}),
    logout: () => null
}